import { JsonUtils } from '../../utils/json.util'
import { TypeGender } from '../user/user'
import { Address } from './address'

export class Patient {

    // Person Data
    private _id: string | undefined
    private _name: string | undefined
    private _sex: string | undefined
    private _cpf: string | undefined
    private _birthday: string | undefined
    private _profession: string | undefined
    private _contact: string | undefined
    private _address: Address | undefined
    private _avatar: any | undefined

    constructor() {
        this._sex = TypeGender.NOT_OPTED
    }

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get name(): string | undefined {
        return this._name
    }
    set name(value: string | undefined) {
        this._name = value
    }
    get sex(): string | undefined {
        return this._sex
    }

    set sex(value: string | undefined) {
        this._sex = value
    }
    get cpf(): string | undefined {
        return this._cpf
    }
    set cpf(value: string | undefined) {
        this._cpf = value
    }

    get birthday(): string | undefined {
        return this._birthday
    }
    set birthday(value: string | undefined) {
        this._birthday = value
    }
    get profession(): string | undefined {
        return this._profession
    }
    set profession(value: string | undefined) {
        this._profession = value
    }
    get contact(): string | undefined {
        return this._contact
    }
    set contact(value: string | undefined) {
        this._contact = value
    }
    get address(): Address | undefined {
        return this._address
    }

    set address(value: Address | undefined) {
        this._address = value
    }
    get avatar(): string | undefined {
        return this._avatar
    }

    set avatar(value: string | undefined) {
        this._avatar = value
    }


    public fromJSON(json: any): Patient {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        // Person Data
        if (json.id !== undefined) {
            this.id = json.id
        }
        if (json.name !== undefined) {
            this.name = json.name
        }
        if (json.sex !== undefined) {
            this.sex = json.sex
        }
        if (json.cpf !== undefined) {
            this.cpf = json.cpf
        }
        if (json.birthday !== undefined) {
            this.birthday = json.birthday
        }
        if (json.profession !== undefined) {
            this.profession = json.profession
        }
        if (json.contact !== undefined) {
            this.contact = json.contact
        }
        if (json.address!== undefined) {
            this.address = json.address
        }
        if (json.avatar !== undefined) {
            this.avatar = json.avatar
        }
        return this
    }
    public toJSON(): any {
        return {
            // Person Data
            id: this.id || undefined,
            name: this.name || undefined,
            sex: this.sex || undefined,
            cpf: this.cpf || undefined,
            birthday: this.birthday || undefined,
            profession: this.profession || undefined,
            contact: this.contact || undefined,
            address: this.address|| undefined,
            avatar: this.avatar || undefined,

        }
    }
}